// Auto-refactored from translations.js on 2026-08-19
// Locale: en

const en = {
  wieMoeglich: { question: 'How is that possible?', answer: 'We have rethought the value chain.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'The STIG ROCK Way',
    fazit: 'The shortened supply chain eliminates the biggest cost positions.',
    fazitBigPre: 'This enables a price discount of up to',
    fazitBigValue: '80%',
    steps: [ 'Mine', 'Cutting facility', 'Certification', 'End customer' ]
  },
  nav: { language: 'Language', contact: 'Contact' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'A Once-in-a-Generation Opportunity',
    subtitle: 'Build wealth, the future-oriented way.',
    description: 'STIG ROCK is an international platform that provides people with access to natural diamonds, sustainable wealth building, and a unique community.',
    scroll: 'Scroll to discover'
  },
  disclaimer: {
    overline: 'Legal Notice',
    title: 'Disclaimer',
    paragraphs: [
      'This presentation is for information purposes only and does not constitute financial, investment or tax advice.',
      'STIG ROCK is not a financial product; it refers to natural diamonds as tangible assets.',
      'No guarantee is given for value appreciation, profits or returns. Past developments are no indication of future results.',
      'All calculations shown in connection with commissions are illustrative only and do not constitute a guarantee.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'BUILT ON', 'STRUCTURE' ],
    body: 'STIG Group is an international holding built on clarity, responsibility and long-term value. Every brand, every venture and every partnership follows a single standard — no shortcuts, no exceptions.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'BUILT ON', 'STRUCTURE' ],
        body: 'STIG Group is an international holding built on clarity, responsibility and long-term value. Every brand, every venture and every partnership follows a single standard — no shortcuts, no exceptions.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'THE WORLD OF', 'EXCLUSIVE DIAMONDS' ],
        body: 'STIG ROCK is a modern concept of the STIG Group, combining premium GIA-certified diamonds with transparent structures and an exclusive client experience. Clear solution plans, professional execution and an international focus.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNATIONAL', 'DIAMOND TRADE' ],
        body: 'STIG International is part of the STIG Group and specialises in the international trade of GIA-certified diamonds. Focused on quality, trust and modern trading structures with global partnerships.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSIBILITY', 'FROM THE MINE' ],
        body: 'Ethical Mines stands for responsible mining, traceable origin and conflict-free diamonds. From the mine to the market — complete documentation ensures transparency, integrity and long-term responsibility along the entire supply chain.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamonds',
    stigDrawback: 'Real store of value',
    overline: 'Pathways',
    title: 'Pathways to Building Wealth',
    subtitle: 'A look at the conventional options.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex or Crypto',
        drawback: 'highly speculative, unpredictable, complex'
      },
      {
        tag: 'Stocks',
        name: 'Equity markets',
        drawback: 'volatility risk, knowledge required, time-intensive'
      },
      {
        tag: 'Crypto',
        name: 'Trading',
        drawback: 'volatility, regulatory risk, security flaws'
      }
    ]
  },
  chance: {
    overline: 'Diamonds',
    title: 'The Underestimated Opportunity',
    body: 'For decades, diamonds have been one of the most value-stable and opportunity-rich asset classes — yet only a few have leveraged their potential.',
    callout: 'With STIG ROCK, we open access to this extraordinary opportunity to everyone — for the first time.'
  },
  wertentwicklung: {
    overline: 'Performance 1995 — 2025',
    title: 'A story about value.',
    usd: 'US Dollar',
    usdValue: '-49%',
    diamond: 'Diamonds',
    diamondValue: '+185%',
    note: 'Performance from 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Key Reasons',
    title: 'Six Reasons for Diamonds',
    lead: 'Diamonds are real tangible assets — independent of currencies and financial systems — that have preserved their value for centuries.',
    items: [
      {
        n: '01',
        title: 'Crisis-proof value',
        body: 'Tangible asset guarantee. Historically preserved value for centuries.'
      },
      {
        n: '02',
        title: 'Ultimate mobility',
        body: 'Small, easy to store and to transport.'
      },
      {
        n: '03',
        title: 'Diversification & scarcity',
        body: 'Supply constraints and natural limitations.'
      },
      { n: '04', title: 'Long-term growth', body: '+185% since 1995.' },
      {
        n: '05',
        title: 'Transparency & exclusivity',
        body: 'The 4 Cʼs guarantee: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Reserve of royal families',
        body: 'Even royal families use diamonds as a wealth reserve.'
      }
    ]
  },
  markt: {
    overline: 'Market Volume',
    title: 'USD 99 — 108 Billion',
    sub: 'Trading volume in 2025',
    unit: 'USD Bn.',
    forecast: 'Forecast through ~2032 / 2034: approx. USD 140 – 168 billion at moderate growth (~4 – 5 % p.a.).',
    source: 'Source: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovation',
    title: 'An innovation. A world first.',
    body: 'STIG ROCK is the first platform in the world that lets people earn passive income in the diamond market in addition to value appreciation.',
    leadershipTag: 'Leadership · Contact',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, UAE',
      'Registration No. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'About the company',
    titleLines: [ 'INTERNATIONAL', 'STRUCTURE', 'CLEAR VISION' ],
    body: 'STIG ROCK was founded to make the diamond market more transparent, more modern and more client-focused — with a focus on trust, security and long-term structure.'
  },
  sicherheit: {
    overline: 'Quality & Security',
    title: 'Gemological Institute of America',
    headline: 'Certified expertise for your diamonds.',
    p1: 'GIA stands for the Gemological Institute of America — the world-leading, independent, non-profit institute for diamond evaluation and the inventor of the global 4C standard (Carat, Clarity, Color, Cut).',
    p2: 'A GIA certificate guarantees the authenticity and natural origin of a diamond as well as an objective, incorruptible documentation of all its quality characteristics.',
    p3: 'For the client this means maximum security and trust: they know exactly what they are buying, pay a fair, quality-appropriate price and own a globally recognised, value-stable diamond that can be resold at any time.',
    body: 'Certified expertise for your diamonds. The GIA evaluates every stone with the utmost precision and decades of experience — reliable assessments for our company and our clients.',
    transparency: 'Every diamond meets the highest quality standards and is examined and certified by renowned organisations. Every stone is unique and receives an individual certificate.'
  },
  kimberleySlide: {
    overline: 'Kimberley Process',
    title: 'We work only with conflict-free diamonds.',
    body: 'The Kimberley Process is an international certification system that prevents the trade of conflict diamonds. Every stone from STIG ROCK is fully traceable and sourced from responsibly certified origins.',
    sealAlt: 'Kimberley Process — Official Seal'
  },
  dualTimeline: {
    overline: 'THE DUAL SYSTEM · VISUAL',
    title: 'One Purchase. Two Paths.',
    intro: 'Your diamond stays safe — its twin gets to work.\n' +
      'Four trading cycles per year generate the discount without your diamond ever being traded.',
    customer: {
      kicker: 'TIMELINE 1',
      title: 'STIG ROCK\nThe Client',
      sub: 'From raw diamond to delivery',
      purchase: 'Purchase',
      cut: 'Cut',
      certify: 'Certification',
      delivery: 'Delivery'
    },
    stig: {
      kicker: 'TIMELINE 2',
      sub: 'One twin · four cycles · active trading',
      cycleSteps: [ 'Purchase', 'Planning', 'Cutting', 'Sale' ],
      footerCycle: '4 × Buy-Cut-Sell',
      footerDiscount: 'Discount → Client'
    },
    summary: {
      stored: 'Diamond safely stored',
      cycles: 'Trading cycles per year',
      months: 'Months duration'
    }
  },
  zertifiziert: {
    overline: 'GIA · Certification',
    title: 'Certified and transparent',
    body: 'Every diamond meets the highest quality standards and is examined and certified by renowned organisations. Every stone is unique and receives an individual certificate.',
    kimberley: 'Kimberley Process — we work exclusively with conflict-free diamonds.'
  },
  plaene: {
    overline: 'Solution Plans (SP)',
    title: 'A unique product innovation',
    sub: 'Seven Solution plans — from $250 to $100k+,\n' +
      'each with rising discounts per month over the entire term.',
    recommended: 'Popular',
    oneYear: '1 year',
    rowLabels: {
      delivery: 'Delivery time',
      price: 'Product price',
      carat: 'Carat',
      monthly: 'Discount (month)',
      totalDiscount: 'Discount (total)',
      duration: 'Duration'
    },
    headers: {
      plan: 'Plan',
      from: 'From',
      carat: 'Carat',
      monthly: 'Discount / month',
      total: 'Total discount',
      duration: 'Duration'
    },
    duration: '1 year',
    footnote: 'All prices are indicative and subject to quality, demand and current market conditions. Solution plans are also available with a 2-year duration.'
  },
  plaeneVIP: {
    overline: 'Solution Plans + VIP Package',
    title: 'More Benefits with the VIP-Paket',
    sub: 'Combine your Solution Plan with a VIP-Paket and benefit from additional price advantages of up to 3%. This way, you increase your overall discount and secure even more attractive terms.',
    rowLabels: {
      delivery: 'Delivery time',
      price: 'Product price',
      carat: 'Carat',
      monthly: 'Discount (month)',
      totalDiscount: 'Discount (total)',
      vip1: 'VIP Package 1 (+1%)',
      vip2: 'VIP Package 2 (+2%)',
      vip3: 'VIP Package 3 (+3%)'
    },
    footnote: 'All prices are indicative and subject to quality, demand and current market conditions.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Client decides whether delivery or sale of their diamond!',
    sub: 'Once your Solution Plan expires you can have your diamond(s) delivered home, or sell them.',
    options: [
      {
        key: 'deliver',
        title: 'Have it delivered',
        body: 'Diamonds (carat) at the price of your Solution Plan.'
      },
      {
        key: 'sellToUs',
        title: 'Sell back to us',
        body: 'You can sell your diamonds back to us at the price you paid.'
      },
      {
        key: 'sellThirdParty',
        title: 'Sell privately on the open market',
        body: 'The client can sell the diamond on the open market themselves!'
      },
      {
        key: 'offer',
        title: 'Automatic purchase offer',
        body: 'Purchase offer 4 weeks before delivery — appears automatically before the Solution Plan expires!'
      }
    ],
    footnote: '*DS Plan stands for Solution Plan.'
  },
  tradWeg: {
    overline: 'Traditional trade',
    title: 'The traditional way',
    sub: 'Before a diamond reaches the end customer, intermediate, wholesale and retail traders add significant trading margins compared to the raw diamond price at the mine.',
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Intermediary', subtitle: 'Rough diamond purchase' },
      { title: 'Cutting workshop', subtitle: 'Cut into jewellery diamonds' },
      { title: 'Certification', subtitle: 'by recognised institutes such as GIA' },
      { title: 'Diamond exchange', subtitle: 'Sale to wholesale' },
      { title: 'Wholesale', subtitle: 'Sale to retail' },
      { title: 'Retail', subtitle: 'e.g. jewellers' },
      { title: 'End customers', subtitle: 'Purchase of diamonds' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: 'Valid for 12 months on all Solution plans you subscribe to. Depending on the VIP package: +1% to +3% additional discount.',
    cardKicker: 'additional – on all',
    cardKicker2: 'Solution plans',
    tip: 'Recommendation: from $2,800 investment volume VIP Package 3 pays off the most.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1,000', bonus: '+3%' }
    ],
    example: {
      title: 'Discounts become savings',
      body: 'Monthly savings instead of monthly costs. Discounts turn into savings — they pay for the things you would normally cover out of pocket every month.',
      line1Label: 'DS-Plan from',
      line1Value: '$5,000',
      line2Label: 'monthly discount',
      line2Value: '3%',
      line3Label: 'VIP Package 3',
      line3Value: '+3%',
      resultLabel: 'monthly savings',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'How is this possible?',
    title: 'We have rethought the value chain.',
    traditionalTitle: 'The traditional path',
    totalLabel: 'End customer price',
    traditionalSteps: [
      'Mine — rough diamonds',
      'Intermediary — purchase',
      'Cutting house — finishing',
      'Certification (GIA)',
      'Diamond exchange — wholesale',
      'Wholesale → retail',
      'Jewellers → end customer'
    ],
    traditionalNote: 'Before a diamond reaches the end customer, intermediaries, wholesalers and retailers introduce considerable margins.',
    stigTitle: 'The STIG ROCK path',
    stigSteps: [
      'Direct purchase — rough diamonds from the mine',
      'Cutting & certification through our partners',
      'Sale to end customers & B2B clients',
      'Up to 4 trading cycles per year'
    ],
    stigNote: 'We break the cycle and pass on the trade margins as discount credits to our clients — up to 4 trading cycles within a DS-Plan duration.'
  },
  optionen: {
    overline: 'Your options',
    title: 'After your Solution plan ends',
    items: [
      { title: 'Delivery', body: 'Receive diamonds (carat) at the value of your DS plan.' },
      { title: 'Sell back to us', body: 'Resell at the original purchase price.' },
      { title: 'Sell to third parties', body: 'Sell your diamonds on the open market.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Plans — a unique product innovation',
    title: 'The simple way',
    caption: '3 · Steps · to Success',
    captionParts: { count: '3', middle: 'Steps', end: 'to Success' },
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Registration',
        body: 'Contact your referrer and create a free account!'
      },
      {
        n: '02',
        icon: 'cart',
        title: 'Purchase a product',
        body: 'From as little as $250'
      },
      {
        n: '03',
        icon: 'discount',
        title: 'Receive discounts',
        body: 'Receive monthly discount credits.'
      }
    ]
  },
  business: {
    overline: 'Bonus types',
    title: 'The fairest, simplest path forward.',
    sub: 'Five bonus categories — for a successful business build-up.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Up to level 3, from rank Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'From Sapphire — infinitely deep.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'On the Infinity Bonus – up to level 5 · NO qualification.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pools of global revenue.'
      },
      {
        name: 'Rank Bonus',
        icon: 'rank',
        value: '$8.325M',
        desc: 'One-time bonus paid in diamonds (carat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'This bonus is paid to you for every newly subscribed Solution plan down to the 3rd level. With minimal qualifications you unlock each level.',
    total: 'Up to 18% Unilevel Bonus',
    totalParts: { prefix: 'Up to', big: '18%', suffix: 'Unilevel Bonus' },
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'from day one',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'from rank Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'from rank Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'From rank Sapphire you qualify for our Infinity Bonus plan. You receive a 3% bonus, and each new rank adds more percentage points. If a partner in your team qualifies too, you earn the difference from rank to rank.',
    exampleTitle: 'Example',
    exampleRows: [
      { label: 'You are Blue Diamond', value: '12%' },
      { label: 'Your partner is Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Your Infinity Bonus', value: '9%' },
    totalNote: 'Total up to 24% Infinity Bonus on every subscribed Solution plan in your team — infinitely deep.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'This bonus lets you benefit from your team’s success. You receive a 5% Matching Bonus on the Infinity Bonus of your partners — down to the 5th level of your team.',
    note: 'On all Infinity Bonus payouts in your team – down to level 5. From day one – with NO qualification.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Up to',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% of the global turnover flows in equal parts into 3 different pools. By reaching certain ranks you qualify for each individual pool.',
    forever: 'Once reached – you participate FOREVER!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'from Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'from Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'from Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'of global turnover'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rank Bonus',
    title: 'Rank Bonus',
    sub: 'From rank Diamond you receive a Rank Bonus. It is paid out in diamonds (carat) as a one-time bonus.',
    highlight: 'Diamonds (carat) worth a total of',
    totalValue: '$8,325,000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5,000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20,000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50,000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100,000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150,000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1,000,000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2,000,000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5,000,000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Career ranks',
    title: 'Career ranks',
    sub: 'Reaching each rank is measured by the historic total revenue (HG). From Sapphire onwards it must be distributed across several teams. To reach Ruby or higher you need at least two direct partners with a Solution plan.',
    forever: 'Once achieved – confirmed FOREVER!',
    footnote: 'HV = Historic total revenue.',
    distributionLabel: '**Distribution:',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', dist: '', perks: [ '1 Unilevel' ] },
      {
        name: 'Pearl',
        coin: 'image83.png',
        hg: '250 HV',
        dist: '',
        perks: [ '2 Unilevels' ]
      },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        dist: '',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25,000 HV*',
        dist: '60%',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50,000 HV*',
        dist: '60%',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250,000 HV*',
        dist: '50%',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1,000,000 HV*',
        dist: '50%',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2,500,000 HV*',
        dist: '40%',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5,000,000 HV*',
        dist: '40%',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10,000,000 HV*',
        dist: '30%',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50,000,000 HV*',
        dist: '30%',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150,000,000 HV*',
        dist: '25%',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500,000,000 HV*',
        dist: '20%',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Get started with us',
    title: 'The right time is now.',
    body: 'This business model sets new standards and unites all factors for a sustainable, successful business in the long run. Register today, choose your Solution plan and seize this one-of-a-kind opportunity.',
    hint: 'Speak with the person who invited you to this presentation — they hold a registration link for you.',
    formName: 'Name',
    formEmail: 'Email',
    formPhone: 'Phone',
    formSubmit: 'Get in touch',
    success: 'Thank you — our team will reach out discreetly and personally.',
    callCta: 'Call',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Legal Notice & Disclaimer',
    disclaimer: 'This presentation is for information purposes only and does not constitute financial, investment or tax advice. STIG ROCK is not a financial product but refers to natural diamonds as tangible assets. No guarantee is given for value developments, gains or returns. Past performance is not an indication of future results. All shown calculations regarding commissions are illustrative only and do not constitute a guarantee. Content subject to change — free translation (not an official translation).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, UAE',
    copy: '© 2026 STIG International. All rights reserved.',
    version: 'Version: DS-12-2025 V3'
  },
  misc: { next: 'Next section' }
};

export default en;
